import { WorkflowActionArgs } from "src/routes/projects/change-events/guided/workflows/types";
import { useGuidedChangeEventActions } from "../sharedSteps/useGuidedChangeEventActions";
import { SwapProductFormInput } from "./swapProductWorkflow";

/** Saves the swap product change event. */
export function useSaveSwapProductChangeEvent(args: WorkflowActionArgs<SwapProductFormInput>) {
  const { saveChangeEvent } = useGuidedChangeEventActions(args, (form) => ({
    materialVariantSwaps: form.swaps.changedValue,
  }));
  return { saveChangeEvent };
}
